import React from 'react';
import classNames from 'classnames';
import { Slider } from '../ui';

import css from './RangeSlider.module.css';

/**
 * A component that renders a range slider using shadcn/ui design.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.rootClassName] - Custom class that overrides the default class for the root element
 * @param {string} [props.className] - Custom class that extends the default class for the root element
 * @param {Array<number>} props.handles - The handles to render (array of [min, max])
 * @param {number} props.min - The minimum value of the range slider
 * @param {number} props.max - The maximum value of the range slider
 * @param {number} props.step - The step value of the range slider
 * @param {function} props.onChange - Callback when slider values change
 * @returns {JSX.Element}
 */
const RangeSlider = props => {
  const { rootClassName, className, handles, min, max, step, onChange, ...rest } = props;
  const classes = classNames(rootClassName || css.root, className);

  // Convert handles array to value array for Slider component
  const value = handles && handles.length >= 2 ? handles : [min, max];

  const handleValueChange = (newValue) => {
    // Call onChange with the new array
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <div className={classes}>
      <Slider
        min={min}
        max={max}
        step={step}
        value={value}
        onValueChange={handleValueChange}
        {...rest}
      />
      <div className={css.valueDisplay}>
        <span className={css.valueText}>{value[0]}</span>
        <span className={css.valueText}>{value[1]}</span>
      </div>
    </div>
  );
};

export default RangeSlider;
